const list = {
  components() {
    return [
      {
        'component': 'search-start-end',
        label: 'TBM 실시일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['Head 3']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({key: 'body.inputB_1', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'body.inputB_1', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }

    return conditions;
  },

  getHead: () => {
    return [
      { name: "사업장명", key: "body.stdInfo.field_name" },
      { name: "소속명", key: "body.stdInfo.department" },
      { name: "부서명", key: "body.stdInfo.section" },
      { name: "TBM 실시일", key: "body.inputB_1" },
      { name: "작성자", key: "body.stdInfo.writer_name" }
    ]
  },
  getCol: (index, value, func) => {
    switch (index) {
    case 0:
      return func.getContent(value).stdInfo.field_name; // 사업장명
    case 1:
      return func.getContent(value).stdInfo.department; // 소속명
    case 2:
      return func.getContent(value).stdInfo.section; // 부서명
    case 3:
      return func.getContent(value).inputB_1; // TBM 실시일
    case 4:
      return func.getContent(value).stdInfo.writer_name; // 작성자
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
  getDefaultSort: () => {
    return {target: 'content$body.inputB_1', order: 'desc'};
  },
};
export default list;
